import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LifeBuoy, X, Send, Loader2, Sparkles } from "lucide-react";
import { apiFetch } from "@/context/AuthContext";

export default function HelpWidget() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [thread, setThread] = useState([]);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const send = async () => {
    if (!msg.trim() || busy) return;
    const q = msg.trim();
    setThread((t) => [...t, { role: "user", text: q }]);
    setMsg(""); setBusy(true);
    try {
      const r = await apiFetch("/help/assistant", { method: "POST", body: { message: q }, auth: false });
      setThread((t) => [...t, { role: "ai", text: r.answer, resolved: r.resolved }]);
    } catch { setThread((t) => [...t, { role: "ai", text: "I'm having trouble right now. Try the Help Center.", resolved: false }]); }
    setBusy(false);
  };

  return (
    <>
      <button onClick={() => setOpen((v) => !v)} className="fixed bottom-6 right-6 z-[9998] w-14 h-14 rounded-full bg-[#0055FF] text-white flex items-center justify-center shadow-[0_0_40px_rgba(0,85,255,0.6)] hover:scale-105 transition-transform duration-300" data-testid="help-widget-toggle" aria-label="Help">
        {open ? <X size={22} /> : <LifeBuoy size={22} />}
      </button>
      {open && (
        <div className="fixed bottom-24 right-6 z-[9998] w-[92vw] max-w-sm rounded-3xl border border-white/10 bg-[#0a0a0a] shadow-2xl overflow-hidden" data-testid="help-widget">
          <div className="px-5 py-4 border-b border-white/10 bg-[#0055FF]/10">
            <p className="font-display font-bold flex items-center gap-2"><Sparkles size={16} className="text-[#00F0FF]" /> ArcaCentum Assistant</p>
          </div>
          <div className="p-4 h-72 overflow-y-auto space-y-3" data-testid="help-widget-thread">
            {thread.length === 0 && <p className="text-slate-500 text-sm">Hi! Ask me anything, or open the full <button onClick={() => { setOpen(false); navigate("/help"); }} className="text-[#00F0FF] underline">Help Center</button>.</p>}
            {thread.map((m, i) => (
              <div key={i} className={m.role === "user" ? "text-right" : ""}>
                <span className={`inline-block px-3 py-2 rounded-2xl text-sm ${m.role === "user" ? "bg-[#0055FF] text-white" : "bg-white/5 text-slate-200"}`}>{m.text}</span>
                {m.role === "ai" && m.resolved === false && <div><button onClick={() => { setOpen(false); navigate("/help"); }} className="text-[10px] text-[#00F0FF] mt-1">Talk to support →</button></div>}
              </div>
            ))}
            {busy && <Loader2 size={16} className="animate-spin text-[#00F0FF]" />}
          </div>
          <div className="p-3 border-t border-white/10 flex gap-2">
            <input value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Ask a question…" className="flex-1 bg-black/40 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none focus:border-[#0055FF]" data-testid="help-widget-input" />
            <button onClick={send} disabled={busy} className="bg-[#0055FF] text-white px-3 rounded-xl disabled:opacity-40" data-testid="help-widget-send"><Send size={16} /></button>
          </div>
        </div>
      )}
    </>
  );
}
